import { render } from "./addBuyer.vue?vue&type=template&id=efc9446a&scoped=true"
import script from "./addBuyer.vue?vue&type=script&lang=js"
export * from "./addBuyer.vue?vue&type=script&lang=js"

import "./addBuyer.vue?vue&type=style&index=0&id=efc9446a&lang=scss&scoped=true"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc9446a"]])

export default __exports__